import { render, staticRenderFns } from "./tabs-content.vue?vue&type=template&id=8f805544&"
import script from "./tabs-content.vue?vue&type=script&lang=ts&"
export * from "./tabs-content.vue?vue&type=script&lang=ts&"
import style0 from "./tabs-content.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports